;(function() {
  'use strict'

  angular.module('app.projects').component('projectsAd', {
    templateUrl: 'projects-ad.html',
  })
})()
